import { useRef, useState } from "react";
import { Camera, Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";

const MAX_PX = 2000;

// ridimensiona a max 2000px e converte in JPEG; restituisce l'originale se non decodificabile
export const compressImage = (file) => new Promise((resolve) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const k = Math.min(1, MAX_PX / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    c.toBlob((b) => {
      if (!b) return resolve(file);
      const ts = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, "");
      resolve(new File([b], `foto_${ts}.jpg`, { type: "image/jpeg" }));
    }, "image/jpeg", 0.85);
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
  img.src = url;
});

// scelta file + scatto da fotocamera (mobile); onChange(file, { fromCamera })
export const FilePicker = ({ accept, onChange, camera = true, testId = "file-picker" }) => {
  const fileRef = useRef(null);
  const camRef = useRef(null);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const pick = async (e, fromCamera) => {
    let f = e.target.files?.[0] || null;
    e.target.value = "";
    if (!f) return;
    if (fromCamera || /^image\/(jpeg|png|heic|heif)$/.test(f.type)) { setBusy(true); f = await compressImage(f); setBusy(false); }
    setName(`${f.name} · ${(f.size / 1024 / 1024).toFixed(2)} MB`);
    onChange(f, { fromCamera });
  };
  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" size="sm" onClick={() => fileRef.current?.click()} data-testid={`${testId}-choose`}><Paperclip className="mr-1 h-4 w-4" />Scegli file</Button>
        {camera && <Button type="button" variant="outline" size="sm" onClick={() => camRef.current?.click()} data-testid={`${testId}-camera`}><Camera className="mr-1 h-4 w-4" />Scatta foto</Button>}
      </div>
      <input ref={fileRef} type="file" accept={accept} className="hidden" onChange={(e) => pick(e, false)} data-testid={`${testId}-input`} />
      {camera && <input ref={camRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => pick(e, true)} data-testid={`${testId}-camera-input`} />}
      <p className="text-xs text-slate-500" data-testid={`${testId}-name`}>{busy ? "Ottimizzazione immagine…" : name || "Nessun file selezionato"}</p>
    </div>
  );
};
